/* PACKAGES */
import { motion } from "framer-motion";

/* CONTAINER ANIMATION */
const containerAnimation = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 1 },
  },
};

/* DIV ANIMATION */
const animation = {
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      damping: 12,
      delay: 1,
      stiffness: 100,
    },
  },
  hidden: {
    opacity: 0,
    y: 20,
    transition: {
      type: "spring",
      damping: 12,
      delay: 1,
      stiffness: 100,
    },
  },
};

const TermsConditions = () => {
  return (
    <motion.section
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
      className="bg-white py-6 xl:py-14 lg:py-14"
    >
      {/* CONTENT */}
      <motion.div variants={animation} className="p-0">
        <div className="container">
          <h1 className="text-4xl font-fraunces-black tracking-tight">
            Terms and Conditions
          </h1>
          <div className="mt-10">
            <p className="text-lg font-source font-normal text-black">
              Welcome to Food Farmacy! These Terms and Conditions govern your
              use of our website and services provided by Food Farmacy ("we,"
              "us," or "our"). By accessing or using our website, you agree to
              be bound by these Terms and Conditions and our Privacy Policy.
              Please read them carefully before using our website.
            </p>

            {/* POINT ONE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Acceptance of Terms
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  By using our website, you agree to comply with these Terms and
                  Conditions. If you do not agree with any part of these Terms
                  and Conditions, you may not access or use our website.
                </li>
              </ul>
            </div>

            {/* POINT TWO */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Use of Website
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  You must be at least 18 years old or have the legal capacity
                  to enter into contracts to use our website. By using our
                  website, you represent that you meet these requirements.
                </li>
                <li className="text-lg font-source font-normal text-black mt-2">
                  You are responsible for maintaining the confidentiality of
                  your account information and for restricting access to your
                  account. You agree to accept responsibility for all activities
                  that occur under your account.
                </li>
              </ul>
            </div>

            {/* POINT THREE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Products and Services
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  Our website offers a variety of healthy food products for
                  sale. We make every effort to accurately display the
                  description and pricing of our products. However, we cannot
                  guarantee that product descriptions or prices are accurate,
                  complete, reliable, current, or error-free.
                </li>
                <li className="text-lg font-source font-normal text-black mt-2">
                  We reserve the right to modify or discontinue any product or
                  service offered on our website without prior notice.
                </li>
              </ul>
            </div>

            {/* POINT FOUR */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Orders and Payments
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  When you place an order on our website, you agree to provide
                  accurate and complete information about yourself, including
                  your billing and shipping address.
                </li>
                <li className="text-lg font-source font-normal text-black mt-2">
                  All payments are processed securely through our payment
                  gateway. By providing your payment information, you authorize
                  us to charge the total amount of your order to your selected
                  payment method.
                </li>
                <li className="text-lg font-source font-normal text-black mt-2">
                  We reserve the right to refuse or cancel any order for any
                  reason, including but not limited to product availability,
                  pricing errors, or suspicion of fraud.
                </li>
              </ul>
            </div>

            {/* POINT FIVE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Shipping and Delivery
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  We offer shipping to locations within the United States.
                  Shipping times and costs may vary depending on your location
                  and the shipping method selected at checkout.
                </li>
                <li className="text-lg font-source font-normal text-black">
                  We are not responsible for any delays, damages, or losses
                  incurred during shipping. Once your order has been shipped, we
                  will provide you with tracking information to monitor the
                  delivery status.
                </li>
              </ul>
            </div>

            {/* POINT SIX */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Returns and Refunds
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  Please refer to our Return Policy for information on returns
                  and refunds.
                </li>
              </ul>
            </div>

            {/* POINT SEVEN */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Intellectual Property
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  All content on our website, including text, graphics, logos,
                  images, and software, is the property of Food Farmacy and
                  protected by copyright and other intellectual property laws.
                  You may not use, reproduce, distribute, or modify any content
                  from our website without our prior written consent.
                </li>
              </ul>
            </div>

            {/* POINT EIGHT */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Limitation of Liability
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  We shall not be liable for any indirect, incidental, special,
                  consequential, or punitive damages arising out of or in
                  connection with your use of our website or products.
                </li>
                <li className="text-lg font-source font-normal text-black">
                  In no event shall our total liability to you exceed the amount
                  paid by you for the products or services purchased from us.
                </li>
              </ul>
            </div>

            {/* POINT NINE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Indemnification
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  You agree to indemnify and hold us harmless from any claims,
                  losses, damages, liabilities, and expenses (including
                  attorney's fees) arising out of or in connection with your use
                  of our website or violation of these Terms and Conditions.
                </li>
              </ul>
            </div>

            {/* POINT TEN */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Governing Law
              </h5>
              <ul className="ml-8 mt-3 list-disc">
                <li className="text-lg font-source font-normal text-black">
                  These Terms and Conditions shall be governed by and construed
                  in accordance with the laws of the India and the State of
                  Gujarat, without regard to its conflict of law principles.
                </li>
              </ul>
            </div>

            <div className="mt-10">
              <p className="text-lg font-source font-normal text-black">
                By using our website and services, you acknowledge that you have
                read and understood these Terms and Conditions. Thank you for
                choosing Food Farmacy for your healthy food needs!
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.section>
  );
};

export default TermsConditions;
